import { useAppSelector } from "@/app/hooks";
import { useUpdatePropertyFieldRuleMutation } from "@/services/survey-properties";
import {
  selectCurrentSurvey,
  selectPropertyFieldRules,
} from "@survey/surveySelectors";
import { getAddressFieldOrder } from "../utils";

export const usePropertyFieldUpdate = () => {
  const currentSurvey = useAppSelector(selectCurrentSurvey);
  const propertyFieldRules = useAppSelector(selectPropertyFieldRules);
  const [updatePropertyFieldRuleApi] = useUpdatePropertyFieldRuleMutation();

  const updateFieldRule = (fieldKey: string, fieldValue: string) => {
    if (!currentSurvey?.id || !fieldValue.trim()) {
      return;
    }
    const order = getAddressFieldOrder(
      fieldKey,
      currentSurvey?.surveyPropertyFieldRule?.activePropertyFieldRuleList ?? [],
      currentSurvey?.surveyPropertyFieldRule?.activePropertyFieldRuleList ?? [],
      currentSurvey?.surveyPropertyFieldRule?.inactivePropertyFieldRuleList ??
        [],
    );

    const field = propertyFieldRules?.find(
      (rule) =>
        rule.fieldKey === fieldKey ||
        rule.fieldLabel === fieldKey ||
        rule.fieldKey?.toLowerCase() === fieldKey.toLowerCase() ||
        rule.fieldLabel?.toLowerCase() === fieldKey.toLowerCase(),
    );
    if (!field) {
      console.warn("Field with key/label not found in property field rules");
      return;
    }

    // Only proceed if field is currently hidden
    if (!field.isHidden) {
      return;
    }
    updatePropertyFieldRuleApi({
      surveyId: currentSurvey.id,
      fieldRuleUpdates: {
        fieldId: field.fieldId,
        isHidden: false,
        order: order,
      },
      propertyLayoutId: "", // Pass the layoutId if needed
    });
  };

  return { updateFieldRule };
};
